import { X } from 'lucide-react'
import {
  dismissCandidatesExportProgress,
  useCandidatesExportProgress,
} from '../lib/candidates-export-progress'

export function CandidatesExportProgressBar() {
  const snap = useCandidatesExportProgress()

  if (snap.status === 'idle') return null

  const accentClass =
    snap.status === 'success'
      ? 'bg-status-success'
      : snap.status === 'error'
        ? 'bg-status-stuck'
        : 'bg-brand-primary'

  return (
    <div
      className="pointer-events-none fixed inset-x-0 bottom-0 z-50 flex justify-center p-4 md:pl-[var(--sidebar-width,0px)]"
      role="status"
      aria-live="polite"
    >
      <div className="pointer-events-auto w-full max-w-xl rounded-xl border border-border-default bg-surface-card p-4 shadow-lg">
        <div className="flex items-start gap-3">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-semibold text-text-primary">{snap.title}</p>
            <p className="mt-0.5 text-xs text-text-secondary">{snap.subtitle}</p>
          </div>
          {snap.status !== 'running' ? (
            <button
              type="button"
              className="rounded-md p-1 text-text-muted hover:bg-surface-workspace hover:text-text-primary"
              aria-label="Dismiss export status"
              onClick={dismissCandidatesExportProgress}
            >
              <X className="h-4 w-4" />
            </button>
          ) : null}
        </div>

        {snap.status === 'running' ? (
          <>
            <div className="mt-3 h-1.5 overflow-hidden rounded-full bg-border-default">
              <div
                className={`h-full rounded-full transition-[width] duration-300 ${accentClass}`}
                style={{ width: `${Math.max(snap.progress * 100, snap.progress === 0 ? 8 : 0)}%` }}
              />
            </div>
            <p className="mt-2 text-[11px] text-text-muted">
              You can keep working — we&apos;ll notify you when your file is ready.
            </p>
          </>
        ) : null}
      </div>
    </div>
  )
}
